import React, {Component} from 'react';
import I18n from 'lib/i18n/i18n';

class Properties extends Component {
    constructor(props) {
        super(props);
        this.buildProperties = this.buildProperties.bind(this);
        this.sellerNotes = this.sellerNotes.bind(this);
    }

    sellerNotes() {
        if (this.props.showSellerNotes && this.props.item.seller_notes) {
            return (
                <div id="seller-notes-section">
                    <h4>{I18n.getString('itemPage::sellerNotes::title')}</h4>
                    <div>{this.props.item.seller_notes}</div>
                </div>
            );
        }
    }

    buildProperties() {
        let subsetI = 0,
            propI = 0,
            ret = [];
        for (const subsetName in this.props.item.subsets) {
            const subset = this.props.item.subsets[subsetName],
                certificate = subset.certificate || subset.properties.Certificate && subset.properties.Certificate.value;
            ret.push(<h4 key={`subsetName${subsetI++}`} className={`${!!certificate ? `subset-certificate-${certificate}` : ''} ${this.props.trends ? 'subset-key' : ''}`}>{subsetName}</h4>);
            for (const propertyName in subset.properties) {
                const propertyValue = subset.properties[propertyName];
                if (!!propertyValue) {
                    ret.push(<div className={`property ${this.props.trends && propertyValue.asm === false ? 'bold-div' : '' }`} key={`property${propI++}`}>
                        <div className="name">{propertyName}
                            <span id="asm-text">{this.props.trends && propertyValue.asm  ? '(est.)' : '' }</span>
                        </div>
                        <div className="value">
                            {propertyValue.value}
                        </div>
                    </div>);
                }
            }
        }
        return ret;
    }

    render() {
        return (
          <div id="properties-section">
              <div className="properties">
                  { this.buildProperties() }
                  { this.sellerNotes() }
              </div>
          </div>
        );
    }
}

export default Properties;